import { faSearchDollar } from "@fortawesome/free-solid-svg-icons";
export const calculationMethodSelection = {
    name: "Calculation Method",
    minSize: [5, 1],
    icon: faSearchDollar,
    description: "Choose calculation method",
    defaultConfig: {
        defaultValue: null,
        key: "Calculation Method",
    },
    type: "input",
    category: "dashboard",
};
